'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TABLE_COLUMNS, _dec, _class, _desc, _value, _class2, _descriptor, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _constants = require('../../constants');

var _mainApplications = require('../page-case/main-applications');

var _util = require('../../utils/util');

var _BaseApplicationsPage = require('../base/BaseApplicationsPage');

var _BaseApplicationsPage2 = _interopRequireDefault(_BaseApplicationsPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var APPLICATION_FACETS_API = _constants.AppConstants.APPLICATION_FACETS_API,
    APPLICATION_MODELS = _constants.AppConstants.APPLICATION_MODELS;


var TABLE_COLUMNS = (_TABLE_COLUMNS = {}, _defineProperty(_TABLE_COLUMNS, APPLICATION_MODELS.LEGAL_FUNDING.model, _mainApplications.OPEN_LEGAL_FUNDING_APPLICATION_COLUMNS), _defineProperty(_TABLE_COLUMNS, APPLICATION_MODELS.MEDICAL.model, _mainApplications.OPEN_MEDICAL_FUNDING_APPLICATION_COLUMNS), _TABLE_COLUMNS);

var ApplicationsPage = (_dec = (0, _mobxReact.inject)('ApplicationStore', 'FunderStore', 'UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(ApplicationsPage, _Component);

  function ApplicationsPage(props) {
    _classCallCheck(this, ApplicationsPage);

    var _this = _possibleConstructorReturn(this, (ApplicationsPage.__proto__ || Object.getPrototypeOf(ApplicationsPage)).call(this, props));

    _initDefineProp(_this, 'columns', _descriptor, _this);

    _this.setColumns(props.FunderStore.defaultApplicationType);
    return _this;
  }

  _createClass(ApplicationsPage, [{
    key: 'setColumns',
    value: function setColumns(selected) {
      var FunderStore = this.props.FunderStore;


      this.columns = FunderStore.isRegistryEnabled ? [].concat(_toConsumableArray(TABLE_COLUMNS[selected]), _toConsumableArray(_mainApplications.REGISTRY_APPLICATION_COLUMNS)) : TABLE_COLUMNS[selected];
    }
  }, {
    key: 'queryMap',
    value: function queryMap(object) {
      return (0, _util.mapObjectKeys)(object, APPLICATION_FACETS_API);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          ApplicationStore = _props.ApplicationStore,
          applicationsPage = _props.UiStore.applicationsPage;

      return _react2.default.createElement(_BaseApplicationsPage2.default, {
        setColumns: this.setColumns,
        queryMap: this.queryMap,
        SidebarComponent: _mainApplications.ApplicationsSidebar,
        fetchCounts: ApplicationStore.fetchOpenCounts,
        fetchData: ApplicationStore.fetchOpen,
        pageName: 'applications',
        pageStore: applicationsPage,
        pageTitle: 'Applications',
        tableColumns: (0, _mobx.toJS)(this.columns),
        tableTitle: 'Open Applications'
      });
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return ApplicationsPage;
}(_react.Component), _class3.propTypes = {
  ApplicationStore: _propTypes2.default.object,
  FunderStore: _propTypes2.default.object,
  UiStore: _propTypes2.default.object
}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'columns', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'setColumns', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'setColumns'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = ApplicationsPage;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(APPLICATION_FACETS_API, 'APPLICATION_FACETS_API', '/app/src/components/page-applications/ApplicationsPage.js');
  reactHotLoader.register(APPLICATION_MODELS, 'APPLICATION_MODELS', '/app/src/components/page-applications/ApplicationsPage.js');
  reactHotLoader.register(TABLE_COLUMNS, 'TABLE_COLUMNS', '/app/src/components/page-applications/ApplicationsPage.js');
  reactHotLoader.register(ApplicationsPage, 'ApplicationsPage', '/app/src/components/page-applications/ApplicationsPage.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-applications/ApplicationsPage.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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